export const getImageId = (bundleMediaFiles, mediaFileType) =>
  bundleMediaFiles.find((mediaFile) => mediaFile.type === mediaFileType)?.id;

// eslint-disable-next-line no-unused-vars
const addressWithoutDeliveryType = ({ deliveryType, ...deliveryAddress }) =>
  deliveryAddress;

export const buildLoanApplicationData = (formData, bundleId, storeCode) => {
  return {
    bundleId,
    ...formData,
    personalIdCountryCode: 'FI',
    deliveryAddress: {
      ...formData.deliveryAddress,
      deliveryType: 'CUSTOMER_ADDRESS',
      countryCode: 'FI',
    },
    invoiceAddress: {
      ...addressWithoutDeliveryType(formData.deliveryAddress),
      countryCode: 'FI',
    },
    deliveryAddressSameAsInvoice: true,
    storeCode: storeCode,
  };
};

export const getDescriptionWithBullets = (description) => {
  return description?.split(';').map((value, index) => {
    return index === 0 ? value : `\u2022 ${value.trim()}`;
  });
};

export const formatPrice = (price) => {
  return price.toFixed(2).toString().replace('.', ',');
};
